export function lightenColor(color: string, percent: number) {
    var usePound = false;

    if (color[0] === '#') {
        color = color.slice(1);
        usePound = true;
    }

    var R = parseInt(color.substring(0, 2), 16);
    var G = parseInt(color.substring(2, 4), 16);
    var B = parseInt(color.substring(4, 6), 16);

    // to make the colour less bright than the input
    // change the following three "+" symbols to "-"
    R = R + percent;
    G = G + percent;
    B = B + percent;

    if (R > 255) R = 255;
    else if (R < 0) R = 0;

    if (G > 255) G = 255;
    else if (G < 0) G = 0;

    if (B > 255) B = 255;
    else if (B < 0) B = 0;

    var RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);

    return (usePound ? '#' : '') + RR + GG + BB;
}

/**
 * Get either black or white font colour depending on background colour
 * source: https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
 */
export function getContrastYIQ(hexcolor: string) {
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }

    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= 128 ? 'black' : 'white';
}

export function getBackgroundGradient(
    color: string,
    type: 'HORIZONTAL' | 'VERTICAL' = 'HORIZONTAL',
    lightenPercent: number = 50
) {
    const lightBgColor = lightenPercent >= 100 ? '#ffffff' : lightenColor(color, lightenPercent);
    return `linear-gradient(${type === 'HORIZONTAL' ? '270deg' : '0deg'}, ${lightBgColor} 0%, ${color} 100%)`;
}
